<div class="customer-culture-wrapper">
    <label *ngIf="selectCultureLabel" style="padding-right:4px;">{{selectCultureLabel}}</label>
    <select class="form-control preferred-language-select" disabled="{{isDisabled}}" [(ngModel)]="selectedCultureName" (change)="cultureChange($event)">
        <option *ngIf="includeEmptyEntry" value="">{{selectCultureEmptyValueText}}</option>
        <option *ngFor="let culture of customerCultures" value={{culture.name}}>{{culture.displayName}}</option>
    </select>
</div>